import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, ViewEncapsulation } 						from '@angular/core';

import { BehaviorSubject, Observable, of, Subject, defer, throwError } 									from 'rxjs';
import { takeUntil, map, tap, take, mergeMap, switchMap, retryWhen, delay } 								from 'rxjs/operators';

// import { InstitutionQualificationService } 			from '@core/services/gwc-api/institution-qualification.service';
// import { InstitutionQualification } 				from '@core/services/gwc-api/types/institution-qualification.types';
// import { OrderService } from '../../services/order.service';
// import { isQuote } from '@angular/compiler';
// import { connectableObservableDescriptor } from 'rxjs/internal/observable/ConnectableObservable';
// import { LoadingComponentService } from '@core/components/loading/loading-component.service';
// import { GwcApiGraduationService } from '@core/services/gwc-api/graduation.service';
// import { InstitutionQualificationRegalia } from '@core/services/gwc-api/types/institution-qualification-regalia.types';
import * as _ from 'lodash-es';
import { CasualHireFormService } from '../../casual-hire-form.service';
import { GwcApiInstitutionQualificationService } from '@gwc/datasources/gwc-api/institution-qualification.service';
import { InstitutionQualification } from '@gwc/datasources/gwc-api/types/institution-qualification.types';
import { LoadingComponentService } from '@gwc/loading/loading-component.service';
import { MatIcon } from '@angular/material/icon';
import { MatChipListbox, MatChipOption } from '@angular/material/chips';
import { AsyncPipe } from '@angular/common';
import { LoadingModule } from '../../../../../../../../@gwc/loading/loading.module';
// import { GwcApiInstitutionQualificationRegaliaService } from '@core/services/gwc-api/institution-qualification-regalia.service';


@Component({
    selector: 'hire-form-select-qualifications',
    templateUrl: './select-qualifications.component.html',
    styleUrls: ['./select-qualifications.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [
        LoadingModule,
        MatChipListbox,
        MatChipOption,
        MatIcon,
        AsyncPipe
    ]
})
export class HireFormSelectQualificationsComponent implements OnInit {

	// @Public Properties
	public institutionQualifications: InstitutionQualification[] = []

	public filteredQualifications$ = new BehaviorSubject<InstitutionQualification[]>([])

	public _selectedInstitutionQualifications: InstitutionQualification[] = [];

	public filters: any = [ { list_qualification_type_id: 'ALL', qualification_type: 'All', status: true} ] 

	public expansionPanelHover: string | null = null;


	// @Private Properties
	private _unsubscribeAll: Subject<any> = new Subject;


	/**
	 * Constructor
	 */
	constructor(
		private _loadingService: LoadingComponentService,
		private _casualHireFormService: CasualHireFormService,
		private _gwcApiInstitutionQualificationService: GwcApiInstitutionQualificationService
	) { }


	//--------------------------------------------------------------------------------
	// @Lifecycle Hooks
	//--------------------------------------------------------------------------------

	/**
	 * On Init
	 */
	ngOnInit(): void {

		this._casualHireFormService.orderData$.pipe(
			take(1),
			switchMap((orderData) => {
				this._selectedInstitutionQualifications = orderData.qualifications

				if(orderData.qualifications.length > 0) {
					this._casualHireFormService.updateStepValidity(true)
				}

				return this._gwcApiInstitutionQualificationService.getByInstitutionId(orderData.institution.institution_id)
			}),
		).subscribe({
			next: (qualifications) => {
				//stop the loader circle
				this._loadingService.stop('qualificationsLoader')

				this.institutionQualifications = _.sortBy(qualifications, ['qualification.qualification']) 
				this.filteredQualifications$.next(this.institutionQualifications as InstitutionQualification[])

				//get the possible qualification types
				this.filters.push(...((_.uniqBy(this.institutionQualifications.map(qual => qual.qualification.qualification_type), 'list_qualification_type_id'))).map(item => _.assign(item, { status: false})));

			}
		})
		
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this._casualHireFormService.updateStepValidity(false)

		this._unsubscribeAll.next(null)
		this._unsubscribeAll.complete()
	}


	//--------------------------------------------------------------------------------
	// @Public Methods
	//--------------------------------------------------------------------------------

	/**
	 * Is the qualification selected
	 */
	 public qualIsSelected(institution_qualification_id: string): boolean {
		return this._selectedInstitutionQualifications.findIndex(qual => qual.institution_qualification_id == institution_qualification_id) > -1
	}

	/**
	 * Toggle the filter
	 */
	public toggleFilter(list_qualification_type_id: string) {
		if(list_qualification_type_id == 'ALL') {
			const currentState = this.filters.find((filter: any)=> filter.list_qualification_type_id == 'ALL').status

			if(!currentState) {
				this.filters.map((filter: any) => filter.status = filter.list_qualification_type_id == 'ALL' ? true : false)
			}

			this._updateFilteredQualificationList(true);

			
		} else {
			const currentStatus = this.filters.find((filter: any) => filter.list_qualification_type_id == list_qualification_type_id).status;
			this.filters.find((filter: any) => filter.list_qualification_type_id == list_qualification_type_id).status = !currentStatus

			if(this.filters.filter((filter: any) => filter.status).length == 0) {
				this.filters.find((filter: any) => filter.list_qualification_type_id == 'ALL').status = true;
				this._updateFilteredQualificationList(true);

			} else {
				this.filters.find((filter: any) => filter.list_qualification_type_id == 'ALL').status = false;
				this._updateFilteredQualificationList(false);
			}		
		}		
	}

	/**
	 * 
	 */
	public toggleQualSelected(institution_qualification: InstitutionQualification): void {

		const q = [...this._selectedInstitutionQualifications];

		if(q.findIndex(qual => qual.institution_qualification_id == institution_qualification.institution_qualification_id) === -1) { 
			//not founnd
			q.push(institution_qualification)

		} else {
			//splice the item
			q.splice(q.findIndex(qual => qual.institution_qualification_id == institution_qualification.institution_qualification_id), 1)

		}

		this._selectedInstitutionQualifications = q;
		this._casualHireFormService.addToOrderData('qualifications', q, q.length > 0 ? true : false)
	}

	public isArrayAndNotEmpty(val: any): boolean {
		return Array.isArray(val) && val.length > 0;
	}


	//--------------------------------------------------------------------------------
	// @Private Methods
	//--------------------------------------------------------------------------------

	//update teh qualifcatiosn list based on the filters
	private _updateFilteredQualificationList(allItems: boolean) {
		if(allItems) {
			this.filteredQualifications$.next(this.institutionQualifications as InstitutionQualification[]);
		} else {
			const quals = this.institutionQualifications.filter((qual: any) => {
				const filterArray = this.filters.filter((filter: any) => filter.status).map((filter: any) => filter.list_qualification_type_id);
				return _.indexOf(filterArray, qual.qualification.list_qualification_type_id) > -1 
			})
			this.filteredQualifications$.next(quals as InstitutionQualification[])
		}
	}


}